module.exports = __webpack_public_path__ + "static/img/banner_01.9dd92a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/banner_01.jpg
// module id = 4zYS
// module chunks = 1